import { isNil } from 'ramda';
import { fetchAndParse } from '../utils/ajax';

export const getTenants = ({ authenticationToken, tenantId }) => fetchAndParse({
    url: '/api/admin/1/organization/tenants',
    method: 'GET',   
    headers: {
        Authorization: authenticationToken,
        ManyWhoTenant: tenantId,
    },
});

export const getUsers = ({ authenticationToken, tenantId }) => fetchAndParse({
    url: '/api/admin/1/organization/users',
    method: 'GET',   
    headers: {
        Authorization: authenticationToken,
        ManyWhoTenant: tenantId,
    },
});

export const sendTenantInvite = ({ authenticationToken, tenantId, invitationTenantName, invitationTenantId }) => {

    const requestData = {};

    // Request body can only contain id or developerName
    if (typeof invitationTenantName === 'string') {
        requestData.developerName = invitationTenantName;
    } else {
        requestData.id = invitationTenantId;
    }

    return fetchAndParse({
        url: '/api/admin/1/organization/invites/tenants',
        method: 'POST',
        headers: {
            Authorization: authenticationToken,
            ManyWhoTenant: tenantId,
            'Content-Type': 'application/json',
        },
        body: requestData,
    });
};

export const sendUserInvite = ({ authenticationToken, invitationEmail, invitationUserId }) => {

    const requestData = {};

    // Request body can only contain id or developerName
    if (!isNil(invitationEmail)) {
        requestData.email = invitationEmail;
    } else {
        requestData.id = invitationUserId;
    }

    return fetchAndParse({
        url: '/api/admin/1/organization/invites/users',
        method: 'POST',
        headers: {
            Authorization: authenticationToken,
            'Content-Type': 'application/json',
        },
        body: requestData,
    });
};

export const getSentTenantInvites = ({ authenticationToken, tenantId }) => fetchAndParse({
    url: '/api/admin/1/organization/invites/tenants',
    method: 'GET',   
    headers: {
        Authorization: authenticationToken,
        ManyWhoTenant: tenantId,
    },
});

export const getSentUserInvites = ({ authenticationToken }) => fetchAndParse({
    url: '/api/admin/1/organization/invites/users',
    method: 'GET',
    headers: {
        Authorization: authenticationToken,
    },
});

export const getReceivedInvites = ({ authenticationToken }) => fetchAndParse({
    url: '/api/admin/1/organization/invites',
    method: 'GET',
    headers: {
        Authorization: authenticationToken,
    },
});

export const acceptTenantInvite = ({ authenticationToken, tenantId, organizationId }) => fetchAndParse({
    url: `/api/admin/1/organization/invites/tenants/${organizationId}`,
    method: 'PUT',
    headers: {
        Authorization: authenticationToken,
        ManyWhoTenant: tenantId,
    },
});

export const rejectTenantInvite = ({ authenticationToken, tenantId, organizationId }) => fetchAndParse({
    url: `/api/admin/1/organization/invites/tenants/${organizationId}`,
    method: 'DELETE',
    headers: {
        Authorization: authenticationToken,
        ManyWhoTenant: tenantId,
    },
});

export const acceptUserInvite = ({ authenticationToken, tenantId, organizationId }) => fetchAndParse({
    url: `/api/admin/1/organization/invites/users/${organizationId}`,
    method: 'PUT',
    headers: {
        Authorization: authenticationToken,
        ManyWhoTenant: tenantId,
    },
});

export const rejectUserInvite = ({ authenticationToken, tenantId, organizationId }) => fetchAndParse({
    url: `/api/admin/1/organization/invites/users/${organizationId}`,
    method: 'DELETE',
    headers: {
        Authorization: authenticationToken,
        ManyWhoTenant: tenantId,
    },
});

// Removes a user from the current organization
export const removeUser = ({ authenticationToken, userId }) => fetchAndParse({
    url: `/api/admin/1/organization/users/${userId}`,
    method: 'DELETE',
    headers: {
        Authorization: authenticationToken,
    },
});

// Removes a tenant from the current organization
export const removeTenant = ({ authenticationToken, tenantId }) => fetchAndParse({
    url: `/api/admin/1/organization/tenants/${tenantId}`,
    method: 'DELETE',
    headers: {
        Authorization: authenticationToken,
    },
});

export const provisionTenantAndOrUser = ({ authenticationToken, provisionData }) => fetchAndParse({
    url: '/api/admin/1/organization/tenants',
    method: 'POST',
    headers: {
        Authorization: authenticationToken,
        'Content-Type': 'application/json',
    },
    body: provisionData,
});

// Fetching an orgs local runtime entities
export const getRuntimes = ({ authenticationToken, tenantId }) => fetchAndParse({
    url: '/api/admin/1/organization/runtimes',
    method: 'GET',
    headers: {
        Authorization: authenticationToken,
        ManyWhoTenant: tenantId,
    },
});

// Fetching a tenants local runtime entities
export const getRuntimesForTenant = ({ authenticationToken, tenantId }) => fetchAndParse({
    url: '/api/admin/1/tenant/runtimes',
    method: 'GET',
    headers: {
        Authorization: authenticationToken,
        ManyWhoTenant: tenantId,
    },
});

// Fetching a single runtime entity
export const getRuntime = ({ authenticationToken, tenantId, id }) => fetchAndParse({
    url: `/api/admin/1/organization/runtimes/${id}`,
    method: 'GET',
    headers: {
        Authorization: authenticationToken,
        ManyWhoTenant: tenantId,
    },
});

// Creating a new local runtime
export const createRuntime = ({ authenticationToken, tenantId, localRuntimeData }) => fetchAndParse({
    url: '/api/admin/1/organization/runtimes',
    method: 'POST',
    headers: {
        Authorization: authenticationToken,
        ManyWhoTenant: tenantId,
        'Content-Type': 'application/json',
    },
    body: localRuntimeData,
});

// Creating a new local runtime
export const updateRuntime = ({ authenticationToken, tenantId, localRuntimeData, localRuntimeId }) => fetchAndParse({
    url: `/api/admin/1/organization/runtimes/${localRuntimeId}`,
    method: 'PUT',
    headers: {
        Authorization: authenticationToken,
        ManyWhoTenant: tenantId,
        'Content-Type': 'application/json',
    },
    body: localRuntimeData,
});

// Deleting a local runtime
export const deleteRuntime = ({ authenticationToken, tenantId, runtimeId }) => fetchAndParse({
    url: `/api/admin/1/organization/runtimes/${runtimeId}`,
    method: 'DELETE',
    headers: {
        Authorization: authenticationToken,
        ManyWhoTenant: tenantId,
        'Content-Type': 'application/json',
    },
});

// Retreiving an organisations tenants
export const getOrgTenants = ({ authenticationToken, tenantId }) => fetchAndParse({
    url: '/api/admin/1/organization/tenants',
    method: 'GET',
    headers: {
        Authorization: authenticationToken,
        ManyWhoTenant: tenantId,
        'Content-Type': 'application/json',
    },
});
